import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';

import { ButtonModule } from 'primeng/button';
import { PopoverModule } from 'primeng/popover';
import { TagModule } from 'primeng/tag';
import { TooltipModule } from 'primeng/tooltip';
import { DialogModule } from 'primeng/dialog';
import { TranslatePipe } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { ExportJobsService } from '../../_services/export-jobs.service';
import { ExportJob } from '../../_models/export-job.model';

/**
 * Trigger compatto "I miei download": una piccola icona con badge (numero di
 * download) che, cliccata, apre una nuvoletta (popover) con la lista dei job
 * di export dell'utente e le azioni (scarica / rimuovi). Si appoggia a
 * ExportJobsService che fa polling e aggiorna la lista in tempo reale.
 * Riutilizzabile ovunque (toolbar di pagina, header globale).
 */
@Component({
	selector: 'app-export-jobs-panel',
	standalone: true,
	imports: [ButtonModule, PopoverModule, TagModule, TooltipModule, DialogModule, TranslatePipe],
	templateUrl: './export-jobs-panel.component.html',
	// Stesso stile dei bottoni messaggi/notifiche dell'header (scoped lì, quindi replicato qui)
	changeDetection: ChangeDetectionStrategy.Eager,
	styles: [
		`
			.notification-bell {
				position: relative;
				background: transparent;
				border: none;
				cursor: pointer;
				padding: 6px;
				border-radius: 50%;
				transition: background-color 0.2s;
			}

			.notification-bell:hover {
				background-color: rgba(255, 255, 255, 0.15);
			}

			.notification-badge {
				position: absolute;
				top: -2px;
				right: -4px;
				background-color: #ef4444;
				color: white;
				font-size: 10px;
				font-weight: 700;
				min-width: 18px;
				height: 18px;
				line-height: 18px;
				text-align: center;
				border-radius: 9px;
				padding: 0 4px;
			}
		`,
	],
})
export class ExportJobsPanelComponent implements OnInit, OnChanges, OnDestroy {
	/** Azienda di contesto: i job mostrati sono quelli dell'utente per questa azienda. */
	@Input() companyId = 0;

	jobs: ExportJob[] = [];
	/** Resoconto mostrato nella modale (info sulla riga). */
	summaryJob: ExportJob | null = null;
	showSummary = false;
	private sub?: Subscription;
	private loadedFor = 0;

	constructor(public exportJobs: ExportJobsService) {}

	ngOnInit(): void {
		this.sub = this.exportJobs.jobs$.subscribe((j) => (this.jobs = j));
		this.maybeLoad();
	}

	// Nell'header globale il companyId arriva da configService.getCompany_id() e puo`
	// valorizzarsi/ cambiare dopo l'init: ricarichiamo quando cambia davvero.
	ngOnChanges(_changes: SimpleChanges): void {
		this.maybeLoad();
	}

	ngOnDestroy(): void {
		this.sub?.unsubscribe();
	}

	private maybeLoad(): void {
		if (this.companyId > 0 && this.companyId !== this.loadedFor) {
			this.loadedFor = this.companyId;
			this.exportJobs.loadMyJobs(this.companyId);
		}
	}

	openSummary(job: ExportJob): void {
		this.summaryJob = job;
		this.showSummary = true;
	}

	severity(stato: string): 'success' | 'danger' | 'warn' | 'secondary' {
		switch (stato) {
			case 'DONE':
				return 'success';
			case 'ERROR':
				return 'danger';
			case 'RUNNING':
				return 'warn';
			default:
				return 'secondary';
		}
	}
}
